import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/index.js";
import { BaseSkeleton } from "./BaseSkeleton.js";
import { skeletonTypographyTypes, skeletonVariants } from "./Skeleton.variants.js";
function Skeleton({ className, type, width, height, emphasis = 'regular', animate = true, slots = {
    skeletonWrapperSlot: '',
    skeletonSlot: '',
    skeletonImageSlot: ''
}, ...props }) {
    const { skeletonWrapperSlot, skeletonSlot, skeletonImageSlot } = skeletonVariants({
        type,
        emphasis,
        animate,
        ...props
    });
    const widthStyle = 'number' == typeof width ? `${width}px` : width;
    const heightStyle = 'number' == typeof height ? `${height}px` : height;
    const styles = {
        width: width ? widthStyle : void 0,
        height: height ? heightStyle : void 0
    };
    return type && type in skeletonTypographyTypes ? /*#__PURE__*/ jsx("div", {
        "data-testid": "skeleton-wrapper",
        className: cn(skeletonWrapperSlot(), slots.skeletonWrapperSlot),
        children: /*#__PURE__*/ jsx(BaseSkeleton, {
            type: type,
            className: className,
            skeletonSlot: cn(skeletonSlot(), slots.skeletonSlot),
            skeletonImageSlot: cn(skeletonImageSlot(), slots.skeletonImageSlot),
            styles: styles
        })
    }) : /*#__PURE__*/ jsx(BaseSkeleton, {
        type: type,
        className: className,
        skeletonSlot: cn(skeletonSlot(), slots.skeletonSlot),
        skeletonImageSlot: cn(skeletonImageSlot(), slots.skeletonImageSlot),
        styles: styles
    });
}
export { Skeleton };
